/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const deliveryChannelSchema = z.enum(['email', 'whatsapp'])

export type DeliveryChannelSchema = z.infer<typeof deliveryChannelSchema>
